export const LOADING_EVALUATION_MONITOR = "LOADING_EVALUATION_MONITOR";
export const SAVE_LOADING_EVALUATION_MONITOR = "SAVE_LOADING_EVALUATION_MONITOR";
export const GET_EVALUATION_MONITOR = "GET_EVALUATION_MONITOR";
export const FORM_FAIL = "FORM_FAIL";
export const EVALUATION_MONITOR_FAIL = "EVALUATION_MONITOR_FAIL";
export const LOADING_EVALUATION_MONITOR_BY_ID = "LOADING_EVALUATION_MONITOR_BY_ID";
export const GET_EVALUATION_MONITOR_BY_ID = "GET_EVALUATION_MONITOR_BY_ID";
export const LOADING_QUESTION_FACTOR = "LOADING_QUESTION_FACTOR";
export const LOADING_QUESTION_COMPETENCY = "LOADING_QUESTION_COMPETENCY";
export const GET_QUESTION_FACTOR = "GET_QUESTION_FACTOR";
export const GET_QUESTION_COMPETENCY = "GET_QUESTION_COMPETENCY";
export const QUESTION_FACTOR_FAIL = "QUESTION_FACTOR_FAIL";
export const QUESTION_COMPETENCY_FAIL = "QUESTION_COMPETENCY_FAIL";